import React from "react";
import { Button, Typography } from "@plum-xoxo/admin-dsm";

const SkipMFAConfirmation = (props) => {
  return (
    <div className="d-flex flex-column">
      <Typography.H3 color="dark" shade="c300">
        Are you sure you want to skip?
      </Typography.H3>
      <Typography.HelperText color="dark" shade="c200" className="mt-4">
        Skipping this step may reduce your account's security. We recommend
        setting up additional authentication methods to ensure your account
        remains protected.
      </Typography.HelperText>
      <div className="mt-32 d-flex">
        <div className="ml-auto">
          <Button variant="plain" onClick={props.skipMFA}>
            Skip and Continue
          </Button>
          <Button onClick={props.goBack} className="ml-12">
            Go Back
          </Button>
        </div>
      </div>
    </div>
  );
};
export default SkipMFAConfirmation;
